module.exports = __webpack_public_path__ + "img/vertical_3_4_0.76cb5e77.png";